module.exports = __webpack_public_path__ + "img/eleksnet.2888b183.png";